/**
 * Canonical estate-administration intake-form sections — the single source of
 * truth for the ordered section list and its human-readable names.
 *
 * A section key is the leading segment of an intake field id (e.g. `aboutYou`
 * in `aboutYou.dateOfBirth`). Both the intake Responses tab (section cards) and
 * the AI-review provenance footnote resolve their section labels from here, so
 * the two can never drift and no surface re-derives a label from the raw key.
 */
export const INTAKE_SECTIONS: ReadonlyArray<{ key: string; name: string }> = [
  { key: 'aboutYou', name: 'About You' },
  { key: 'aboutDeceased', name: 'About the Deceased' },
  { key: 'aboutWill', name: 'About the Will' },
  { key: 'family', name: 'Family' },
  { key: 'assets', name: 'Assets' },
  { key: 'businessInterests', name: 'Business & Trusts' },
  { key: 'liabilities', name: 'Liabilities' },
  { key: 'financialAdvisor', name: 'Financial Advisor' },
  { key: 'accountant', name: 'Accountant' },
  { key: 'otherInformation', name: 'Other Information' }
] as const;

/** Section key → display name lookup, derived from {@link INTAKE_SECTIONS}. */
export const INTAKE_SECTION_LABELS: Record<string, string> = Object.fromEntries(
  INTAKE_SECTIONS.map((s) => [s.key, s.name])
);
